@import 'styles/mixins';
@import 'styles/variables';

.root {
  align-items: center;
  border: 1px solid transparent;
  display: flex;
  width: 28px;
  height: 28px;

  &.black svg {
    fill: $almanac-black;
  }

  &.gray svg {
    fill: $gray-40;
  }

  &.blue-50 svg {
    fill: $blue-50;
  }
}
